import { House, MessageCircleMore, University, UserPen } from "lucide-react"
import { useState } from "react"
import ProfilUser from "../profil/ProfilUser"
import Dh_homeComponent from "../homeDh/Dh_home"
import Dh_university from "../university/Dh_university"
import Dh_Utilisateurs from "../utilisateurs/Dh_Utilisateurs"
import Dh_messages from "../messages/Dh_messages"

export default function Dh_main() {
  const [activeSection, setActiveSection] = useState("home")
  

  const sections = [

    { id: "home", name: "Home", icon: <House className="h-4 w-4 mr-2" /> },
    { id: "profiAmin", name: "Profil", icon: <UserPen className="h-4 w-4 mr-2" /> },
    { id: "utilisateurs", name: "utilisateurs", icon: <UserPen className="h-4 w-4 mr-2" /> },
    { id: "message", name: "Messages", icon:<MessageCircleMore className="h-4 w-4 mr-2"/>  },
    { id: "universitys", name: "Universitys", icon: <University className="h-4 w-4 mr-2" /> },

  ]

  return (
    <div className="">
      <button data-drawer-target="default-sidebar" data-drawer-toggle="default-sidebar" aria-controls="default-sidebar" type="button" className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
        <span className="sr-only">Open sidebar</span>
       <svg classname="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path cliprule="evenodd" fillrule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z" />
</svg>

      </button>
      <aside id="default-sidebar" className="fixed px-9 w-[200px] ... mtAsideDashboard top-0 left-0  h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar">
        <div className=" py-4 overflow-y-auto border mt-10 border-gray-300 dark:border-gray-700 rounded-lg  bg-gray-50 dark:bg-[#121c31] ">
          <div className="max-w-7xl  mx-auto">
            <div className="flex  space-x-8 overflow-x-auto">
              <ul className="space-y-2 font-medium">
                {sections.map((section) => (
                  <li
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                    className={`flex items-center ml-3 py-2 px-1 text-sm border-b-2 font-medium cursor-pointer ... dark:text-gray-200 whitespace-nowrap ${activeSection === section.id
                      ? "border-indigo-500 text-indigo-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                  >
                    {section.icon}
                    <span>{section.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </aside>

      <div className="py-4 sm:ml-56">
        <div className=" z-50    dark:border-gray-700">
          {/*  */}
          {activeSection === "home" && (
            <div className="-ml-10 -mt-5">
            <Dh_homeComponent/>
            </div>
          )}


          {/* Section Profile */}
          {activeSection === "profiAmin" && (
            <div className="-ml-20 -mt-20">
              <ProfilUser />
            </div>
          )}
          {activeSection === "universitys" && (
            <div className="-ml-20 ">
              <Dh_university />
            </div>
          )}
          {activeSection === "utilisateurs" && (
            <div className="-ml-20 ">
              <Dh_Utilisateurs />
            </div>
          )}
          {activeSection === "message" && (
            <div className="-ml-20 ">
              <Dh_messages />
            </div>
          )}
        </div>
      </div>
    </div>

  )
}
